import { Directive, ElementRef, Renderer2, OnInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appFade]',
})
export class FadeDirective implements OnInit, OnDestroy {
  private fadeDuration = 200; // Duration in milliseconds

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.setupFadeEffect();
    this.fadeIn();
  }

  ngOnDestroy() {
    this.fadeOut();
  }

  private setupFadeEffect() {
    // Set initial styles for fade effect
    this.renderer.setStyle(this.el.nativeElement, 'opacity', '0');
    this.renderer.setStyle(
      this.el.nativeElement,
      'transition',
      `opacity ${this.fadeDuration}ms ease`
    );
  }

  private fadeIn() {
    // Show element and start fade-in transition
    setTimeout(() => {
      this.renderer.setStyle(this.el.nativeElement, 'opacity', '1');
    }, 10); // Delay to ensure 'display' is applied before opacity transition
  }

  private fadeOut() {
    // Start fade-out transition and hide element after transition completes
    this.renderer.setStyle(this.el.nativeElement, 'opacity', '0');
    setTimeout(() => {}, this.fadeDuration); // Wait for fade-out transition before hiding
  }
}
